import React from 'react';
import { Tooltip } from '../../Tooltip';
import { Input } from '../../Input';
import { toDateFormat, isValid, } from '../../../utilities/dateFormat';
export const DateRangeInput = React.forwardRef(({ value, placeholder, onBlur, error, autoFocus, onFocus, onKeyPress, dateFormat, }, ref) => {
    const [IValue, setIValue] = React.useState(value === null ? '' : toDateFormat.numeric(new Date(value)));
    const [dateValue, setDateValue] = React.useState('');
    React.useEffect(() => {
        var _a;
        setDateValue((_a = (value &&
            toDateFormat.numeric(new Date(value), {
                locales: dateFormat === null || dateFormat === void 0 ? void 0 : dateFormat.locales,
            }))) !== null && _a !== void 0 ? _a : '');
    }, [dateFormat, value]);
    const handleOnChange = (data) => {
        setDateValue(data);
    };
    const handleOnBlur = () => {
        const currentAsDate = new Date(dateValue);
        if (isValid(currentAsDate)) {
            setDateValue(toDateFormat.numeric(currentAsDate, {
                locales: dateFormat === null || dateFormat === void 0 ? void 0 : dateFormat.locales,
            }));
            setIValue(toDateFormat.numeric(currentAsDate));
            onBlur === null || onBlur === void 0 ? void 0 : onBlur(currentAsDate);
        }
        else {
            setDateValue(IValue);
        }
    };
    const selectAllText = (e) => {
        onFocus === null || onFocus === void 0 ? void 0 : onFocus();
        e.target.select();
    };
    return (React.createElement(Tooltip, { open: error, text: error, direction: "b" },
        React.createElement(Input, { onBlur: handleOnBlur, onKeyPress: onKeyPress, onChange: (e, value) => handleOnChange(value.value), error: error, onFocus: selectAllText, placeholder: placeholder, value: dateValue, icon: "event", iconPosition: "left", fluid: true, className: "m-0", autoFocus: autoFocus, inputRef: ref })));
});
//# sourceMappingURL=DateRangeInput.js.map